import React from 'react';
import { motion } from 'framer-motion';
import { HelpCircle, AlertTriangle, FileQuestion } from 'lucide-react';
export function ProblemSection() {
  const problems = [{
    icon: <HelpCircle className="w-8 h-8 text-brand-gold" data-id="element-223" />,
    title: 'No entienden el sistema',
    desc: 'Las reglas del crédito en USA son confusas y nadie te las enseña cuando llegas o cumples la mayoría de edad.'
  }, {
    icon: <AlertTriangle className="w-8 h-8 text-brand-gold" data-id="element-224" />,
    title: 'Cometen errores sin saberlo',
    desc: 'Cierran cuentas, aplican a demasiadas tarjetas o usan más del límite permitido, destruyendo su puntaje.'
  }, {
    icon: <FileQuestion className="w-8 h-8 text-brand-gold" data-id="element-225" />,
    title: 'Información incompleta',
    desc: 'Toman decisiones basadas en mitos, consejos de amigos o información desactualizada de internet.'
  }];
  return <section className="py-20 bg-brand-gray" data-id="element-226">
      <div className="container mx-auto px-6 max-w-6xl" data-id="element-227">
        <motion.div className="text-center max-w-3xl mx-auto mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-228">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-brand-black mb-6" data-id="element-229">
            Si tu crédito no mejora, no es por falta de esfuerzo…{' '}
            <span className="text-brand-green" data-id="element-230">es por falta de estrategia</span>
          </h2>
          <p className="text-lg text-gray-600" data-id="element-231">
            Muchas personas se sienten estancadas financieramente porque el
            sistema está diseñado para ser complejo.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-232">
          {problems.map((problem, index) => <motion.div key={index} className="bg-brand-green p-8 rounded-2xl shadow-premium text-center" initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.15
        }} data-id="element-233">
              <div className="w-16 h-16 mx-auto bg-brand-gold/20 rounded-full flex items-center justify-center mb-6" data-id="element-234">
                {problem.icon}
              </div>
              <h3 className="text-xl font-bold text-white mb-3" data-id="element-235">
                {problem.title}
              </h3>
              <p className="text-white/80 leading-relaxed" data-id="element-236">{problem.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}